import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

// --- Component ---
import { ConfirmUnloadDialog } from './confirm-unload.component';

// --- Dialogs ---

@NgModule({
	declarations: [ConfirmUnloadDialog],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		// --- PrimeNG ---
		ButtonModule,
		DropdownModule,
		InputMaskModule,
		InputNumberModule,
		InputTextModule,
		InputTextareaModule,
	],
	exports: [ConfirmUnloadDialog],
})
export class ConfirmUnloadModule {}
